export default __webpack_public_path__ + "static/media/sound-on.073c7f9c.png";